import React from 'react';

const Alterfailure = (props) => {
    return (
        <div class="alert alert-danger text-center my-alert" role="alert">
             <p>{props.errmsg || 'Something went horribly wrong!'}</p>
        </div>
    );
}

export default Alterfailure;